<app-pen
    [hidden]="!showPen"
    cdkDrag
    cdkDragBoundary=".body"
    (closed)="onClose()"
>
    <app-handle cdkDragHandle>
        <i class="fas fa-arrows-alt"></i>
    </app-handle>
</app-pen>

<app-highlighter
    [hidden]="!showHighlighter"
    cdkDrag
    cdkDragBoundary=".body"
    (closed)="onClose()"
>
    <app-handle cdkDragHandle>
        <i class="fas fa-arrows-alt"></i>
    </app-handle>
</app-highlighter>

<app-eraser
    [hidden]="!showEraser"
    cdkDrag
    cdkDragBoundary=".body"
    (closed)="onClose()"
>
    <app-handle cdkDragHandle>
        <i class="fas fa-arrows-alt"></i>
    </app-handle>
</app-eraser>
